import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useThemeStore = create(
  persist(
    (set, get) => ({
      isDark: false,

      toggleTheme: () => {
        const newTheme = !get().isDark
        set({ isDark: newTheme })
        document.documentElement.classList.toggle('dark', newTheme)
      },

      setTheme: (isDark) => {
        set({ isDark })
        document.documentElement.classList.toggle('dark', isDark)
      },

      initializeTheme: () => {
        document.documentElement.classList.toggle('dark', get().isDark)
      },
    }),
    {
      name: 'veralis-theme-storage',
    }
  )
)

export default useThemeStore
